export default [
  {
    path: 'csi-codes',
    meta: {
      title: 'CSI Codes',
      auth: ['Admin', 'Super Admin'],
      hidden: false
    },
    component: () => import('./pages/index'),
    redirect: 'csi-codes/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'csiCodes',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'csiCodes',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'csiCodes',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      },
      {
        path: 'tree',
        // name: 'admin.orders.prep-categories.tree',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Sort & Group',
          resource: 'csiCodes',
          icon: 'drag handle',
          hidden: false
        },
        component: () => import('./pages/tree')
      },
    ]
  }
]
